import {BenjiKIVRingGirl} from "../view/general/enhancer/BenjiKIVRingGirl";

/**
 * Created by Jerker Nord on 2022-12-08.
 */

export class BenjiKIVPoolRingGirls {

    private _ringGirls:BenjiKIVRingGirl[];

    public init():void {
        this._ringGirls = [];
        for(let i:number = 0; i < 5; i++) {
            this._ringGirls.push(this.createRingGirl());
        }
    }

    private createRingGirl():BenjiKIVRingGirl {
        return new BenjiKIVRingGirl();
    }

    public getGirl():BenjiKIVRingGirl {
        for(let i:number = 0; i < this._ringGirls.length; i++) {
            if(this._ringGirls[i].isUsed == false) {
                this._ringGirls[i].isUsed = true;
                return this._ringGirls[i];
            }
        }
        //console.log("Creating more Ring Girls!");
        this._ringGirls.push(this.createRingGirl());
        return this.getGirl();
    }
}